import { render, staticRenderFns } from "./TablaTrabajadores.vue?vue&type=template&id=382ec632&scoped=true"
import script from "./TablaTrabajadores.vue?vue&type=script&lang=js"
export * from "./TablaTrabajadores.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382ec632",
  null
  
)

export default component.exports